export class AdminTemplateSettingItem {
    constructor(
        public id: string,
        public name: string,
        public type: 'entry' | 'entity',
        public isChangedOnWeb: boolean
    ) { }
}
